export const CONTEXTS_QUERY_KEY = ['me', 'contexts'] as const;
